import { Component } from '@angular/core';
import { AuthService } from '../../../services/auth.service';
import { Router } from '@angular/router';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  
  email: string = ''; 
  showEnterOtp: boolean = false; 

  constructor(private authService: AuthService,private router: Router, private toaster: ToastService ) { }

  forgotPassword(): void {
    const userData = {email : this.email}; 

    this.authService.forgotPassword(userData).subscribe(
      {
        next:(response) => {
          this.toaster.showToast('OTP sent, please check your email', 'info'); 
          this.showEnterOtp = true;
        },
        error:(error) => {
          this.toaster.showToast('Invalid email', 'error');
          console.error("Error", error);
        }
      }
    )
  }
}
